import { createFileRoute } from '@tanstack/react-router'

import SwastaPage from '@/components/pages/backoffice/_ktg-penyuluh/swasta/containers/SwastaPage'

export const Route = createFileRoute('/_backoffice/ktg-penyuluh/swasta/')({
  component: SwastaPage
})
